import styled from 'styled-components';

export const MainContainer = styled.div`
  /* margin-top: 120px; */
  margin-left: 250px;
  padding: 16px;
  width: calc(100% - 250px);
`;